import init from '@/utils/init'
import App from './home.vue'

init(App);



























